import { InjectionToken } from '@angular/core';

export const travelerTranslationToken = new InjectionToken('travelerTranslationToken');
export const travelerOperatorConfigToken = new InjectionToken('traveler.operator.config');
export const travelerAppConfigToken = new InjectionToken('traveler.app.config');
